import { getUserConnectorConfigurations } from '../dataServices/MappingDataService';
import moment from 'moment-timezone';

const isLoggedIn = async () => {
    return window.localStorage.getItem("haveUser") === 'true';
}

const convertUTCDate = (date: string) => {
    return moment.utc(date, "YYYY-MM-DD HH:mm:ss").local().format("DD MMM yyyy hh:mm A");
}
const convertLocalDate = (date: string) => {
    return moment(new Date(date)).format("DD MMM yyyy hh:mm A");
}

const getTimezoneFromFirebase = async (userId: string, connectorId: string) => {
    const user = await getUserConnectorConfigurations(userId, connectorId);
    user?.result?.mappings?.synchronizationFeatures?.accountTimezone ? localStorage.setItem("timezone", user?.result?.mappings?.synchronizationFeatures?.accountTimezone) : localStorage.removeItem("timezone");
};

const userTimezone = (date: string) => {
    return moment(new Date(date)).tz(localStorage.timezone ? localStorage.timezone : moment.tz.guess()).format("DD MMM yyyy hh:mm A");
};

const getUserTimezoneStartAndEndOfADay = (date: string) => {
    const startDayTime = "00:00:01";
    const endDayTime = "23:59:59";

    var startOfTheDay = moment(date + 'T' + startDayTime);
    var endOfTheDay = moment(date + 'T' + endDayTime);

    var startAt = moment.tz(startOfTheDay, localStorage.timezone).utc().format();
    var endAt = moment.tz(endOfTheDay, localStorage.timezone).utc().format();

    return { startAt, endAt }
}

// src/utils/cookieUtils.ts
export const setCookie = (name: string, value: string, options: any = {}) => {
    const { expires, path, domain, secure, sameSite } = options;

    let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (expires) {
        if (expires instanceof Date) {
            cookieText += `; expires=${expires.toUTCString()}`;
        } else if (typeof expires === 'number') {
            const date = new Date();
            date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000));
            cookieText += `; expires=${date.toUTCString()}`;
        }
    }

    if (path) cookieText += `; path=${path}`;
    if (domain) cookieText += `; domain=${domain}`;
    if (secure) cookieText += '; secure';
    if (sameSite) cookieText += `; samesite=${sameSite}`;

    document.cookie = cookieText;
};

export const getCookie = (name: string): string | null => {
    const nameEQ = `${encodeURIComponent(name)}=`;
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
        }
    }
    return null;
};

export const removeCookie = (name: string) => {
    setCookie(name, '', { expires: new Date(0) });
};

export { isLoggedIn, convertUTCDate, convertLocalDate, getTimezoneFromFirebase, userTimezone, getUserTimezoneStartAndEndOfADay };